export const getNumberOfLoops = (
  availableDuration: number,
  effectDuration: number
): number => {
  return Math.min(
    Math.max(1, Math.floor(availableDuration / effectDuration)),
    100
  );
};
